import './style.css'; 
import { IoMenuSharp } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { useSelector, useDispatch } from 'react-redux';
import { toggleClose, toggleOpen } from '../../store/sidebarToggleSlice';
import { themeLight, themeBW, themeDark } from '../../store/themeSlice';
import { FaPowerOff, FaUserLarge } from "react-icons/fa6";
import NotifcationDrawer from '../notificationDrawer/NotificationDrawer';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import ReturnSidebar from '../returnSidebar/ReturnSidebar';
import Cookies from 'js-cookie';
import { logout } from '../../store/authSlice';
import socket from '../../socket/socket';
import { updateUserSession } from '../../api/endPoints/authentication';
import { useSocketEvent } from '../../store/hooks/useSocketEvent';


const Navbar = () => {
  const dispatch: any = useDispatch()
  const [dropmenu, setMenu] = useState<boolean>(false);
  const [visibleSidebar, setVisibleSidebar] = useState<boolean>(false)
  const [visibleNotificationBar, setNotificationBar] = useState<boolean>(false)
  const history: any = useNavigate()
  let pathname: any = (window.location.pathname).split('/').pop();

  const theme: any = useSelector((state: any) => {
    return state.theme.isTheme;
  })

  useEffect(() => {
    document.body.setAttribute('data-theme', theme)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  const ShowMenu = () => {
    setMenu(!dropmenu);
    setNotificationBar(false)
  }
  // Sidenav Toggle
  const toggle = useSelector((state: any) => {
    return state.sidebarToggle.isOpen;
  })

  //Dispatching sidenav 
  const toggleSidebar = () => {
    setNotificationBar(false)
    setMenu(false)
    { (toggle === false) ? dispatch(toggleOpen()) : dispatch(toggleClose()) }
  };
  //Dispatching Notification
  const handleNotificationDrawer = () => {
    setNotificationBar(!visibleNotificationBar)
  }

  const handleProfile: any = () => {
    setMenu(false)
    history('/profile')
  }

  //Dispatchong theme
  const changeTheme = () => {
    if (theme === 'light') dispatch(themeDark());
    else if (theme === 'dark') dispatch(themeBW());
    else if (theme === 'b&w') dispatch(themeLight());
  };





  useSocketEvent('adminActivityUpdated', (item: any) => {
    const userDetailsCookies: any = Cookies.get('details')
    const userDataParsed: any = userDetailsCookies ? JSON.parse(userDetailsCookies) : { "email": "", "expiry": "", "userName": "", "isLoggedIn": false }

    let localStorageNotificationEnabledResponse: any = localStorage.getItem('notificationEnabled') ? localStorage.getItem('notificationEnabled') : JSON.stringify(false)

    if ((localStorageNotificationEnabledResponse !== (item?.b_is_notification_enabled))  && (item['email_id'] === userDataParsed?.email)) {
      localStorage.setItem('notificationEnabled', item?.b_is_notification_enabled)
    }
    if ((item['email_id'] === userDataParsed?.email) && (item['is_active'] === false)) {
      handleLogout(item)
    }
  },[])

  useSocketEvent('privilegeInserted', (privilegeItem: any) => {
    handleLogout(privilegeItem)
  },[])

  useSocketEvent('privilegeDeleted', (privilegeItem: any) => {
    handleLogout(privilegeItem)
  },[]) 

  useSocketEvent('privilegeUpdated', (privilegeItem: any) => {
    handleLogout(privilegeItem)
  },[])

  useSocketEvent('sessionUpdated', (privilegeItem: any) => {
    // handleLogout(privilegeItem)
    handleLogoutOnAdminActivity(privilegeItem)
  },[])


  const handleLogoutOnAdminActivity = (data:any) => {
    const userDetailsCookies: any = Cookies.get('details')
    const userDataParsed: any = userDetailsCookies ? JSON.parse(userDetailsCookies) : { "email": "", "expiry": "", "userName": "", "isLoggedIn": false }

    if ((data?.s_username === userDataParsed?.email) && (userDataParsed?.unid === data?.s_login_id)) {
      Cookies.remove('details');
      Cookies.remove('codesArray');
      dispatch(logout())
      history('/')
    }
  }



  const handleLogout = (data: any) => {
    
    const userDetailsCookies: any = Cookies.get('details')
    const userDataParsed: any = userDetailsCookies ? JSON.parse(userDetailsCookies) : { "email": "", "expiry": "", "userName": "", "isLoggedIn": false }
    if (data?.s_username === userDataParsed?.email) {
      Cookies.remove('details');
      Cookies.remove('codesArray');
      dispatch(logout())
      history('/')
      window.location.reload();
    }
  }

  const handleOnclickLogout = async (e:any) => {
    e.preventDefault();

    const userDetailsCookies: any = Cookies.get('details')
    const userDataParsed: any = userDetailsCookies ? JSON.parse(userDetailsCookies) : { "email": "", "expiry": "", "userName": "", "isLoggedIn": false, "unid":"" }

    await updateUserSession(userDataParsed?.email, userDataParsed?.unid)
    Cookies.remove("details");
    Cookies.remove("codesArray");
    dispatch(logout());
    history("/");
    window.location.reload();
  }

  const ref = useRef<any>(null);
  const handleClickOutside = (event: MouseEvent) => {
    if ((ref.current && !ref.current.contains(event.target))) {
      setMenu(false)
    }
  };
  document.addEventListener('click', handleClickOutside, true);
  return (
    <>
      <nav className="navbar">
        <div className="navLeft">
          <button className="btn btn-square btn-ghost " onClick={toggleSidebar}>
            {toggle ? <RxCross2 /> : <IoMenuSharp />}
          </button>

          <span>
            <img
              src="/images/feedsense_ai_logo1.png"
              style={{ width: "100%", height: "100%", cursor: "pointer" }}
              onClick={() => history("/live")}
            />
          </span>
        </div>
        <div className="navRight">
          <span className='sebiNumber'>SEBI RA INH000018382 </span> 
          
          <button onClick={changeTheme} className="icons">
            <span className="theme">
              {theme === "dark" ? (
                <img
                  alt="dark_light"
                  src="/svgImage/dark-mode-6682.svg"
                  width="20px"
                  height="20px"
                />
              ) : theme === "light" ? (
                <img
                  className="icon_light"
                  alt="light_light"
                  src="/svgImage/light_light.svg"
                  width="25px"
                  height="25px"
                />
              ) : (
                <img
                  alt="bw_light"
                  src="/icons/bw_light.png"
                  width="1.3rem"
                  height="1.3rem"
                />
              )}
            </span>
          </button>
          <button
            className="icons"
            onClick={handleNotificationDrawer}
            id="notif_bell"
          >
            <span
              className="svg common_click"
              id="notif_bell"
            >
              <img
                alt=""
                className="common_click"
                src="/images/bell-icon-16.png"
              />
            </span>
          </button>
          <div className="dropMenu" style={{ paddingRight: `${pathname !== "live" ? "2rem" : ""}` }}>
            <button className="icons" onClick={(e:any) => {
              handleOnclickLogout(e)
            }}>
              <span>
                <FaPowerOff />
              </span>
            </button>
          </div>
          {pathname === "live" && (
            <div>
              <div className="sideBar_return">
                <button
                  className="float_sidebar"
                  id=""
                  onClick={() => {
                    setVisibleSidebar(!visibleSidebar);
                    setNotificationBar(false);
                  }}
                >
                  <div className="arrow1">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>
      <ReturnSidebar
        setVisibleSidebar={setVisibleSidebar}
        visibleSidebar={visibleSidebar}
      />
      <NotifcationDrawer
        visibleNotificationBar={visibleNotificationBar}
        setNotificationBar={setNotificationBar}
      />
    </>
  );
};
export default Navbar;